import { Center, Icon, Tooltip } from '@chakra-ui/react';
import { EyeOffIcon, EyeIcon } from '@heroicons/react/solid';

type Props = {
  showKeys: boolean;
  setShowKeys: (showKeys: boolean) => void;
};

export function ToggleKeysVisibility({
  showKeys,
  setShowKeys
}: Props): JSX.Element {
  return (
    <Tooltip
      label={showKeys ? 'Hide sensitive keys' : 'Show all keys'}
      aria-label={showKeys ? 'Hide sensitive keys' : 'Show all keys'}
      closeOnClick={false}
    >
      <Center as="button" onClick={() => setShowKeys(!showKeys)}>
        <Icon as={showKeys ? EyeOffIcon : EyeIcon} boxSize={5} />
      </Center>
    </Tooltip>
  );
}
